import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { fetchAdmissions } from '../../../store/actions/admissionsActions';
import AutocompleteSelect from '../../elements/form/AutocompleteSelect';
import { authHeader, baseUrl } from '../../../utils';
import axios from 'axios';
import ModalActionButton from '../../elements/ModalActionButton';
import Loader from '../../elements/Loader';
import { ERROR, SET_SUCCESS } from '../../../store/types';
import OTPInput from '../../elements/form/OtpInput';

const MoveApplication = ({application, close, refresh}) => {
    const dispatch = useDispatch()
    const admissionsSelector = useSelector((state => state.admissions))
    const [validationErrors, setValidationErrors] = useState({})

    const [selectedOpening, setSelectedOpening] = useState(null)

    const validateForm = () => {
        let errors = {}

        if(!selectedOpening || selectedOpening === ''){
            errors.state = true
        }

        if(providingOtp && (!otp || otp === '')){
            errors.otp = true
        }
        setValidationErrors(errors)
    
        return errors
    }

    useEffect(() => {
        dispatch(fetchAdmissions(`active=true`, 0, 0))
        return () => {
        
        };
    }, [dispatch]);

    const [moving, setMoving] = useState(false)
    const [providingOtp, setProvidingOtp] = useState(false)

    const moveApplicationToOpening = async () => {
        if (Object.values(validateForm()).includes(true)) {
            return
        }

        try{
            setMoving(true)
            const headers = authHeader()
            await axios.get(`${baseUrl}/applications/${application._id}/move/${selectedOpening}`, {headers})
            setProvidingOtp(true)
            setMoving(false)
        }
        catch(error){
            console.log(error)
            dispatch({
                type: ERROR,
                error
            })
            setProvidingOtp(false)
            setMoving(false)
        }
    }

    const [otp, setOtp] = useState('')

    const confirmApplicationMove = async () => {
        if (Object.values(validateForm()).includes(true)) {
            return
        }

        try{
            setMoving(true)
            const headers = authHeader()
            await axios.post(`${baseUrl}/applications/move`, { confirmationCode: otp }, {headers})
            setProvidingOtp(true)
            setMoving(false)

            dispatch({
                type: SET_SUCCESS,
                payload: 'Application moved successfully!'
            })
            refresh()
            close()
        }
        catch(error){
            console.log(error)
            dispatch({
                type: ERROR,
                error
            })
            setProvidingOtp(false)
            setMoving(false)
        }
    }
    return (
        <>
            {admissionsSelector?.loadingAdmissions 
            ? 
                <Loader />
            :
                <div className='w-full'>
                    <p className="text-sm">Please select an active opening below to move the application <span className="font-[550]">{application.applicationCode}</span> for <span className="font-[550]">{application.firstName} {application.lastName}</span> to.</p>
                    {!providingOtp && <>
                        {admissionsSelector?.admissions?.admissions?.length > 0 
                            ? 
                                <div className='w-full mt-4'>
                                    <AutocompleteSelect
                                        selectOptions = {admissionsSelector?.admissions?.admissions || []}
                                        inputLabel = "Select an active opening"
                                        requiredField={true}
                                        titleField = "title"
                                        displayImage = {false}
                                        imageField = ""
                                        placeholderText={`Select an active opening`}
                                        fieldId = {`class-parent`}
                                        preSelected={''}
                                        preSelectedLabel='_id'
                                        hasError = {validationErrors && validationErrors.state}
                                        returnFieldValue={(value)=>{setSelectedOpening(value._id)}}
                                    />
                                </div> 
                            : 
                            <p className="text-sm text-red-600 mt-4 p-2 rounded-md bg-red-100 border border-red-400">No active openings found. Please create a new opening first.</p>
                        }
                    </>}

                    {providingOtp && <div className='w-full mx-auto mt-[20px] pt-[20px] border-t border-gray-300'>
                        <p className='text-sm text-green-800 mb-[10px]'>Please check your email. We sent a 6-digit OTP to approve this action.</p>
                        <OTPInput length={6} onChange={(value) => {setOtp(value)}} />
                    </div>}

                    <div className="mt-8 flex flex-row-reverse gap-x-4">
                        <ModalActionButton
                            buttonLabel={providingOtp ? `Confirm Application Move` : `Move Application`}
                            buttonAction={()=>{providingOtp ? confirmApplicationMove() : moveApplicationToOpening()}}
                            processing={moving}
                        />

                        <button
                            type="button"
                            className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                            onClick={close}
                        >
                            Close
                        </button>
                        
                    </div>
                </div>
            }
        </>
    )
}

export default MoveApplication